import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { FORMS, MODULES } from "../../../const";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import LoadingSpinner from "../../LoadingSpinner";
import Input from "../../input/Input";
import Dropdown from "../../input/Dropdown";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import { User } from "react-feather";
import SearchDropdown from "../../input/SearchDropdown";

const FORM = FORMS.CALL_CENTER_SHIFT_GROUP.SHIFT_STK.form;
const ShiftGroupStakeholder = forwardRef(
  ({ errors, dropdown, isLoading, currentValues, editMode }, ref) => {
    //dropdown
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [yesNoOptions, setYesNoOptions] = useState([]);

    //bool
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [fieldReset, setFieldReset] = useState(false);

    const [initialActive, setInitialActive] = useState(
          editMode ? currentValues?.sgcActive : 1,
        );

    const [shiftGroupStkData, setShiftGroupStkData] = useState(
      editMode
        ? {
            ...currentValues,
          }
        : {
            sgcCode: "",
            sgcReferance: "",
            sgcCompany: null,
            sgcGroup: null,
            sgcStakeholders: [],
            sgcDescription: "",
            sgcStatus: 2,
            sgcActive: 1,
          }
    );
    useEffect(() => {
      (async () => {
        if (editMode) {
          const formattedOutput =
            currentValues?.shiftGroupCompaniesDropdownResponse.reduce(
              (acc, item) => {
                acc[item.id] = item.text;
                return acc;
              },
              {}
            );
          setShiftGroupStkData((prevState) => ({
            ...prevState,
            sgcStakeholders: formattedOutput,
            // sgcStatus:currentValues.currentValues,
          }));
        }
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      (async () => {
        //new

        const { active, status } = await getBulkDropdownData([
          { key: "active" },
          { key: "status" },
        ]);

        setActiveOptions(active);
        setStatusOptions(status);
      })();
    }, []);

    const [currentErrors, setCurrentErrors] = useState({});
    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    useImperativeHandle(ref, () => ({
      getData: () => shiftGroupStkData,

      isDeletedActive: () =>
        shiftGroupStkData.sgcActive === 2 && initialActive !== 2,
      resetForm: () => {
        setShiftGroupStkData({
          sgcCode: "",
          sgcReferance: "",
          sgcCompany: null,
          sgcGroup: null,
          sgcStakeholders: [],
          sgcDescription: "",
          sgcStatus: 2,
          sgcActive: 1,
        });
        setSearchFieldReset(true);
        setCurrentErrors({});
      },
    }));
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Shift Group</h4>
              <div className="two fields">
                <Input
                  label="Company Code"
                  error={currentErrors.sgcCode}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sgcCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="shgCode"
                  value={shiftGroupStkData.sgcCode}
                  onChange={(e) => {
                    setShiftGroupStkData((prevState) => ({
                      ...prevState,
                      sgcCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
                {/*<Input*/}
                {/*    label="Group Reference"*/}
                {/*    error={currentErrors.shgReferance}*/}
                {/*    module={MODULES.Master}*/}
                {/*    form={FORM}*/}
                {/*    field="shg_referance"*/}
                {/*    editMode={editMode}*/}
                {/*    resetError={() =>*/}
                {/*        setCurrentErrors((prevState) => {*/}
                {/*            const {shgReferance: _, ...rest} = prevState;*/}
                {/*            return rest;*/}
                {/*        })*/}
                {/*    }*/}
                {/*    name="shgReferance"*/}
                {/*    value={shiftGroupsData.shgReferance}*/}
                {/*    onChange={(e) => {*/}
                {/*        setShiftGroupsData((prevState) => ({*/}
                {/*            ...prevState,*/}
                {/*            shgReferance: e.target.value,*/}
                {/*        }));*/}
                {/*    }}*/}
                {/*    disabled={true}*/}
                {/*/>*/}
              </div>
              <div className="two fields">
                <SearchDropdown
                  required={true}
                  label="Stakeholder"
                  error={currentErrors.sgcStakeholders}
                  module={MODULES.Master}
                  form={FORM}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sgcStakeholders: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Stakeholder"
                  // value={shiftGroupStkData.sgcStakeholders}
                  multiple={true}
                  // multiGridCurrentValue={shiftGroupStkData.sgcStakeholders}
                  reset={fieldReset}
                  setReset={setFieldReset}
                  multiValueRemoveHandler={(key) => {
                    setShiftGroupStkData((prevState) => {
                      const { [key]: _, ...rest } = prevState.sgcStakeholders;
                      return { ...prevState, sgcStakeholders: rest };
                    });
                  }}
                  onResultSelect={(data) => {
                    setShiftGroupStkData((prevState) => ({
                      ...prevState,
                      sgcStakeholders: {
                        ...prevState.sgcStakeholders,
                        [data.key]: data.title,
                      },
                    }));
                    // setShiftGroupStkData((prevState) => ({
                    //     ...prevState,
                    //     sgcStakeholders: [...prevState.sgcStakeholders, data],
                    // }))
                  }}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Customer",
                  }}
                  multiValueTwoWayBinding={true}
                  multiValues={shiftGroupStkData.sgcStakeholders}
                  returnFullObject={true}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Description"
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_description"
                  editMode={editMode}
                  placeholder="Description"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftGroupStkData.sgcDescription}
                  onChange={(e) => {
                    setShiftGroupStkData((prevState) => ({
                      ...prevState,
                      sgcDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.sgcStatus}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_status"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sgcStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  value={shiftGroupStkData.sgcStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftGroupStkData((prevState) => ({
                      ...prevState,
                      sgcStatus: data.value,
                    }));
                  }}
                />

                <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.sgcActive}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_active"
                  // authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sgcActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  value={shiftGroupStkData.sgcActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftGroupStkData((prevState) => ({
                      ...prevState,
                      sgcActive: data.value,
                    }));
                  }}
                />
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: shiftGroupStkData.createdBy
                      ? shiftGroupStkData.createdBy
                      : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: shiftGroupStkData.createdDate
                      ? formatFromJsonDate(shiftGroupStkData.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: shiftGroupStkData.lastModifiedBy
                      ? shiftGroupStkData.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: shiftGroupStkData.lastModifiedDate
                      ? formatFromJsonDate(shiftGroupStkData.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
      </>
    );
  }
);
export default ShiftGroupStakeholder;
